import { DDSHeadlineText } from "@web-monorepo/dds";
import { isProduction } from "#/src/utils/env";

export function ModuleError({ error }: { error: unknown }) {
  if (isProduction) {
    return (
      <DDSHeadlineText i18n-context="Error page if there's a problem loading a piece of the application">
        Loading Error
      </DDSHeadlineText>
    );
  }

  if (error instanceof Error) {
    return (
      <>
        <DDSHeadlineText i18n-context="Error page if there's a problem loading a piece of the application">
          Loading Error
        </DDSHeadlineText>
        <pre>{error.stack}</pre>
      </>
    );
  }
  return (
    <DDSHeadlineText i18n-context="Error page if there's a problem loading a piece of the application">
      Unknown module error
    </DDSHeadlineText>
  );
}
